const getDisplayName = (document) => {
  let title;
  if (document.title) {
    title = document.title;
  } else if (document.Title) {
    title = document.Title;
  } else if (document.filename) {
    title = document.filename
      .replace(/\.pdf$/, '')
      .replace(/\.doc$/, '')
      .replace(/\.docx$/, '');
  } else {
    title = '';
  }

  return title.replace(/_/g, ' ');
};

const getAvailableHeight = () => {
  // This is a hacky way to estimate how much vertical space we have in which to fit the list of snippets
  return document.getElementsByTagName('html')[0].clientHeight;
};

const getAvailableWidth = () => {
  // This is a hacky way to estimate how much vertical space we have in which to fit the list of snippets
  return document.getElementsByTagName('html')[0].clientWidth;
};

const copyToClipboard = (str) => {
  // This function is based on: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);

  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;

  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};

const clusterColor = (cluster) => {
  // This color scheme is schemeCategory10 from d3-scale-chromatic, with the grey removed
  const colors = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#bcbd22',
    '#17becf'
  ];

  if (cluster.is_outlier) {
    return '#7f7f7f';
  }
  return colors[cluster.id % colors.length];
};

const enableUploads =
  process.env.REACT_APP_ENABLE_UPLOADS &&
  process.env.REACT_APP_ENABLE_UPLOADS.toLowerCase() === 'true';

export {
  getDisplayName,
  getAvailableHeight,
  getAvailableWidth,
  copyToClipboard,
  clusterColor,
  enableUploads
};
